<template>
  <div class="garanties-list">
    <div class="clients__title">
      Garanties souscrites
    </div>

    <!-- Filter bar matching project design -->
    <div class="garanties-filter">
      <div class="garanties-filter--wrap">
        <div class="garanties-filter__fields">
          <div class="garanties-filter__fields--block">
            <div class="garanties-filter__fields--item field-wrap--amount">
              <label class="label">
                <span class="font-regular label--title">Numéro de contrat</span>
                <div class="label__input-wrap">
                  <input
                    type="text"
                    v-model="filters.quote_number"
                    placeholder=""
                    @keyup.enter="onFilterSubmit"
                  />
                </div>
              </label>

              <label class="label">
                <span class="font-regular label--title">Nom du client</span>
                <div class="label__input-wrap">
                  <input
                    type="text"
                    v-model="filters.client_name"
                    placeholder=""
                    @keyup.enter="onFilterSubmit"
                  />
                </div>
              </label>

              <label class="label">
                <span class="font-regular label--title">Société</span>
                <div class="label__input-wrap">
                  <input
                    type="text"
                    v-model="filters.company"
                    placeholder=""
                    @keyup.enter="onFilterSubmit"
                  />
                </div>
              </label>
            </div>

            <div class="garanties-filter__fields--item field-wrap--date">
              <div class="label currency-datepicker">
                <span class="label--title">
                  Date
                  <span v-if="dateRangeFilled" class="label--reset" @click="clearDateRange">X</span>
                </span>
                <div class="label__input-wrap">
                  <datepicker
                    placeholder="De"
                    format="DD/MM/YYYY"
                    :monday-first="true"
                    :full-month-name="true"
                    wrapper-class="currency-datepicker__wrapper-low-margin"
                    input-class="currency-datepicker__input"
                    calendar-class="currency-datepicker__element"
                    v-model="filters.start_date"
                  >
                  </datepicker>
                </div>
                <div class="label__input-wrap">
                  <datepicker
                    placeholder="à"
                    format="DD/MM/YYYY"
                    :monday-first="true"
                    :full-month-name="true"
                    wrapper-class="currency-datepicker__wrapper-low-margin"
                    input-class="currency-datepicker__input"
                    calendar-class="currency-datepicker__element"
                    v-model="filters.end_date"
                  >
                  </datepicker>
                </div>
              </div>
            </div>
          </div>

          <div class="garanties-filter__buttons">
            <button class="garanties-filter__buttons--button" @click="onFilterSubmit">Rechercher</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Table section matching previous .clients__table design -->
    <template v-if="isLoading">
      <Preloader />
    </template>
    <template v-else>
      <div class="clients__table">
        <template v-if="garanties.data && garanties.data.length > 0">
          <div class="clients__table__item clients__table__header">
            <div class="clients__table__item--cell">Date</div>
            <div class="clients__table__item--cell">N° Garantie</div>
            <div class="clients__table__item--cell small_wider">Client / Praticien</div>
            <div class="clients__table__item--cell">Société</div>
            <div class="clients__table__item--cell little_wider">Matériel</div>
            <div class="clients__table__item--cell">N° Série</div>
            <div class="clients__table__item--cell super_smaller">Durée</div>
            <div class="clients__table__item--cell">Date d'effet</div>
            <div class="clients__table__item--cell">Date de fin</div>
            <div class="clients__table__item--cell smaller">Prime</div>
            <div class="clients__table__item--cell text-center" title="Contrat de garantie">Contrat de garantie</div>
          </div>
          <div class="clients__table__item" v-for="garanty in garanties.data" :key="garanty.id">
            <div class="clients__table__item--cell">{{ parseDate(garanty) }}</div>
            <div class="clients__table__item--cell">{{ garanty.quote_number || ' - ' }}</div>
            <div class="clients__table__item--cell small_wider" :title="parseFullName(garanty)">{{ parseFullName(garanty) }}</div>
            <div class="clients__table__item--cell" :title="parseCompany(garanty)">{{ parseCompany(garanty) }}</div>
            <div class="clients__table__item--cell little_wider" :title="parseMaterial(garanty)">{{ parseMaterial(garanty) }}</div>
            <div class="clients__table__item--cell" :title="parseSerialNumber(garanty)">{{ parseSerialNumber(garanty) }}</div>
            <div class="clients__table__item--cell super_smaller">{{ garanty.duration ? garanty.duration + ' mois' : ' - ' }}</div>
            <div class="clients__table__item--cell">{{ parseEffectiveDate(garanty) }}</div>
            <div class="clients__table__item--cell">{{ parseEndDate(garanty) }}</div>
            <div class="clients__table__item--cell smaller">{{ parsePrice(garanty) }}</div>
            <div class="clients__table__item--cell icon-cell text-center">
              <font-awesome-icon
                prefix="fas"
                icon="file-pdf"
                @click="downloadCertificate(garanty.id)"
                title="Télécharger le contrat de garantie"
                style="cursor: pointer;"
              />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="subscribes-empty">Il n'y a aucun client pour ce type de garantie à ce jour.</div>
        </template>
      </div>

      <pagination
        :data="garanties"
        @pagination-change-page="fetchGuarantees"
        :limit="10"
      >
      </pagination>
    </template>
  </div>
</template>

<script>
import Preloader from '@/components/Preloader';
import Datepicker from '@/components/DatepickerCustom/src/components/Datepicker';

export default {
  name: 'DentalGuaranteesSubscribed',
  components: { Preloader, Datepicker },
  data() {
    return {
      garanties: {
        data: [],
      },
      filters: {
        quote_number: '',
        client_name: '',
        company: '',
        status: '',
        start_date: null,
        end_date: null,
      },
      currentPage: 1,
      isLoading: false,
    };
  },
  computed: {
    dateRangeFilled() {
      return !!(this.filters.start_date || this.filters.end_date);
    },
  },
  methods: {
    clearDateRange() {
      this.filters.start_date = null;
      this.filters.end_date = null;
    },
    parseDate(garanty) {
      const dateVal = garanty.subscription_date || garanty.created_at;
      if (!dateVal) return ' - ';
      return this.moment(dateVal).format('DD/MM/YYYY');
    },
    parseFullName(garanty) {
      if (garanty && garanty.dental_client && garanty.dental_client.name) {
        return garanty.dental_client.name;
      }
      return ' - ';
    },
    parseCompany(garanty) {
      if (garanty && garanty.dental_client && garanty.dental_client.company) {
        return garanty.dental_client.company;
      }
      return ' - ';
    },
    parseMaterial(garanty) {
      if (garanty && Array.isArray(garanty.details) && garanty.details.length > 0) {
        const d = garanty.details[0];
        const parts = [];
        if (d.manufacturer) parts.push(d.manufacturer);
        if (d.material_designation) parts.push(d.material_designation);
        return parts.length > 0 ? parts.join(' - ') : (d.brand || ' - ');
      }
      return ' - ';
    },
    parseSerialNumber(garanty) {
      if (garanty && Array.isArray(garanty.details) && garanty.details.length > 0) {
        return garanty.details[0].serial_number || ' - ';
      }
      return ' - ';
    },
    parseEffectiveDate(garanty) {
      if (garanty && garanty.effective_date) {
        return this.moment(garanty.effective_date).format('DD/MM/YYYY');
      }
      return ' - ';
    },
    parseEndDate(garanty) {
      if (garanty && (garanty.effective_date_end || garanty.end_date)) {
        return this.moment(garanty.effective_date_end || garanty.end_date).format('DD/MM/YYYY');
      }
      return ' - ';
    },
    parsePrice(garanty) {
      return (garanty && (garanty.price !== null && garanty.price !== undefined))
        ? this.roundEURWithoutSymbol(garanty.price) + ' €'
        : ' - ';
    },
    parseStatusGaranty(garanty) {
      if (garanty && garanty.status) {
        switch (garanty.status) {
          case 'Active':
            return 'Valide';
          case 'Inactive':
            return 'Annulée';
          case 'Expired':
            return 'Echue';
          case 'Credited':
            return 'Sans Effet';
          default:
            return garanty.status;
        }
      }
      return ' - ';
    },
    onFilterSubmit() {
      this.currentPage = 1;
      this.fetchGuarantees(1);
    },
    fetchGuarantees(page = 1) {
      this.isLoading = true;
      this.currentPage = page;

      const params = {
        page: this.currentPage,
        sort: 'subscription_date|desc',
      };

      if (this.filters.quote_number) {
        params.quote_number = this.filters.quote_number.trim();
      }
      if (this.filters.client_name) {
        params.client_name = this.filters.client_name.trim();
      }
      if (this.filters.company) {
        params.company = this.filters.company.trim();
      }
      if (this.filters.status) {
        params.status = this.filters.status;
      }
      if (this.filters.start_date) {
        params.subscription_date_start = this.moment(this.filters.start_date).format('YYYY-MM-DD');
      }
      if (this.filters.end_date) {
        params.subscription_date_end = this.moment(this.filters.end_date).format('YYYY-MM-DD');
      }

      this.apiGet('dental/guarantees', params, false)
        .then((response) => {
          if (response && response.data) {
            this.garanties = response.data;
          }
        })
        .catch((error) => {
          console.error('Error fetching dental guarantees:', error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    downloadCertificate(id) {
      if (!id) return;
      window.open(this.getApiAuthUrl('dental/guarantees/' + id + '/certificate') + '&show_type=download', '_blank');
    },
  },
  mounted() {
    this.fetchGuarantees(1);
  },
};
</script>

<style scoped>
.clients__table {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.clients__table__header {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Dental/DentalGuaranteesSubscribed.vue